import type { LengthBasedProduct, RidgeOption } from "../types";

const getRidgeAndHipFixings = (
  getProductQuantity: (productCode: string) => number,
  ridge?: RidgeOption,
  hip?: LengthBasedProduct
): number => {
  const ridgeTileQuantity = ridge ? getProductQuantity(ridge.code) : 0;
  const isSameProduct = ridge && hip && ridge.code === hip.code;
  const hipTileQuantity =
    hip && !isSameProduct ? getProductQuantity(hip.code) : 0;

  return ridgeTileQuantity + hipTileQuantity;
};

export default getRidgeAndHipFixings;
